import React from "react";

export default (props: React.SVGAttributes<SVGElement>) => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M4.5 5V9.35C4.5 10.25 4.81667 11.0167 5.45 11.65C6.08333 12.2833 6.85 12.6 7.75 12.6L18.15 12.6L14.3 8.75L15.35 7.7L21 13.35L15.35 19L14.3 17.95L18.15 14.1L7.75 14.1C6.45 14.1 5.33333 13.6375 4.4 12.7125C3.46667 11.7875 3 10.6667 3 9.35V5H4.5Z" fill="black"/>
</svg>
;
